// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "memories-" + chunkId + ".js?v=" + {"vendors-node_modules_webworker-typed_dist_index_js-node_modules_workbox-expiration_index_mjs":"1167d2310d216107265e","components_frame_XImgWorker_ts":"8929d0dd1752427884a4"}[chunkId] + "";
};